"use client";

import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";

import { Link } from "@/shared/i18n/routing";
import { tp } from "@/shared/utils/typograf";
import { APP_BASE_URL } from "@/shared/constants/appBaseUrl";

import FinzyIcon from "@/shared/icons/logos/finzy.svg";
import { Button } from "@/shared/components/button";
import { LanguageSwitcher } from "@/shared/components/language-switcher";

const navKeys = [
  "purchase",
  "transfers",
  "payments",
  "services",
  "opportunities"
] as const;

/** Небольшой порог, чтобы пилюля не мигала от инерции тачпада у самого верха. */
const SCROLL_THRESHOLD = 16;

export const Header = () => {
  const t = useTranslations("header");
  const tNav = useTranslations("common.nav");
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const sync = () => setIsScrolled(window.scrollY > SCROLL_THRESHOLD);

    sync();
    window.addEventListener("scroll", sync, { passive: true });

    return () => window.removeEventListener("scroll", sync);
  }, []);

  return (
    <header className="fixed z-30 inset-x-0 top-0 px-4 lg:px-6">
      <div
        data-scrolled={isScrolled || undefined}
        className="header-pill max-w-300 mx-auto flex items-center"
      >
        <Link href="/" className="inline-flex pressable">
          <FinzyIcon className="w-16 h-8" />
        </Link>
        {/* На мобильном навигация не помещается в пилюлю — те же ссылки есть в футере. */}
        <nav className="hidden lg:block mx-auto">
          <ul className="flex items-center gap-4">
            {navKeys.map((key) => (
              <li key={key}>
                <Link
                  href={`#${key}`}
                  className="inline-flex px-5 py-2 text-sm leading-5 transition-opacity hover:opacity-70"
                >
                  {tp.execute(tNav(key))}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="ml-auto flex items-center gap-3 lg:gap-5">
          <LanguageSwitcher />
          <Button
            size="sm"
            className="px-6 lg:px-10"
            render={
              <a
                href={APP_BASE_URL}
                target="_blank"
                rel="noopener noreferrer"
              />
            }
          >
            <span>{tp.execute(t("login"))}</span>
          </Button>
        </div>
      </div>
    </header>
  );
};
